import { TabFallback } from '@/components/TabFallback';
import { Suspense, lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

// Lazy-load the page modules so the auth bundle doesn't bloat the
// initial chunk — matches the convention established by `me.routes.tsx`.
// Login is the user-facing sign-in entry surface; AuthCallback and Logout
// are recovery surfaces the happy path rarely renders, so deferring all
// three is the right default.
const Login = lazy(() => import('@/pages/Login').then((m) => ({ default: m.Login })));
const AuthCallback = lazy(() =>
  import('@/pages/AuthCallback').then((m) => ({ default: m.AuthCallback })),
);
const Logout = lazy(() => import('@/pages/Logout').then((m) => ({ default: m.Logout })));

// No `handle` field on any entry: all three are public-by-design routes
// (siblings of `/maintenance` and `/`) and do NOT participate in the
// `RequireAuth` / `requiredPermissions` chain that `AuthedLayout`
// children use. `RootGate`'s `UNAUTH_SURFACES` allowlist short-circuits
// the maintenance gate so these routes stay reachable mid-sign-in/out
// even during a maintenance window.
export const authRoutes: RouteObject[] = [
  {
    path: '/auth/login',
    element: (
      <Suspense fallback={<TabFallback />}>
        <Login />
      </Suspense>
    ),
  },
  {
    path: '/auth/callback',
    element: (
      <Suspense fallback={<TabFallback />}>
        <AuthCallback />
      </Suspense>
    ),
  },
  {
    path: '/auth/logout',
    element: (
      <Suspense fallback={<TabFallback />}>
        <Logout />
      </Suspense>
    ),
  },
];
